/* eslint-disable */
import { atom } from "recoil";
import dayjs from "dayjs";
import RECOIL_KEYS from "../constants/recoilKeys";
import {
  KycDetails,
  RecipientDetails,
  UserDetails,
  UserTransactionDetails,
  OfflineFlywire,
  OfflineWesternUnion,
  OfflineSBM,
  EsignedStatus,
  userTransactionRemarks,
  declarationDetails,
  VendorCode,
  Categories,
  AdditionalDocList,
  HistoryPageEsignModalProps,
} from "./store";
import { recoilPersist } from "recoil-persist";

const { persistAtom } = recoilPersist();

export const userDetails = atom({
  key: RECOIL_KEYS.USER_DETAILS,
  default: {} as UserDetails,
});

export const searchValue = atom({
  key: RECOIL_KEYS.SEARCH_VALUE,
  default: "",
});

export const recipientDetails = atom({
  key: RECOIL_KEYS.RECIPIENT_DETAILS,
  default: {} as RecipientDetails,
});

export const transactionDetails = atom({
  key: RECOIL_KEYS.USER_TRANSACTION_DETAILS,
  default: {} as UserTransactionDetails,
});

export const additionalData = atom({
  key: RECOIL_KEYS.ADDITIONAL_DATA,
  default: [] as Categories,
});

export const userAdditionalDocs = atom({
  key: RECOIL_KEYS.USER_ADDITIONAL_DOC,
  default: {} as AdditionalDocList,
});

export const declarationDefault = atom({
  key: RECOIL_KEYS.DECLARATION_DETAILS,
  default: {
    vendorCode: "",
    lanNumber: null,
    paymentUtr: null,
  } as declarationDetails,
});

export const transactionRemarks = atom({
  key: RECOIL_KEYS.USER_TRANSACTION_REMARKS,
  default: {} as userTransactionRemarks,
});

export const kycDetails = atom({
  key: RECOIL_KEYS.KYC_DETAILS,
  default: {} as KycDetails,
});

export const confirmedPurpose = atom({
  key: RECOIL_KEYS.CONFIRMED_PURPOSE,
  default: { value: "Select Purpose", code: "" },
});

export const offlineFlywire = atom({
  key: RECOIL_KEYS.OFFLINE_FLYWIRE,
  default: {} as OfflineFlywire,
});

export const offlineWesternUnion = atom({
  key: RECOIL_KEYS.OFFLINE_WESTERN_UNION,
  default: {} as OfflineWesternUnion,
});

export const offlineSBM = atom({
  key: RECOIL_KEYS.OFFLINE_SBM,
  default: {} as OfflineSBM,
});

export const isMasterVendor = atom({
  key: RECOIL_KEYS.MASTER_VENDOR,
  default: false,
});

export const openLoanModal = atom({
  key: RECOIL_KEYS.LOAN_MODAL,
  default: false,
});

export const isEsigned = atom({
  key: RECOIL_KEYS.ESIGN_STATUS,
  default: {} as EsignedStatus,
});

export const vendorCodes = atom({
  key: RECOIL_KEYS.VENDOR_CODES,
  default: {} as VendorCode,
});

export const bene = atom({
  key: RECOIL_KEYS.Bene,
  default: false,
});

export const isResigned = atom({
  key: RECOIL_KEYS.IS_RESIGNED,
  default: false,
});

export const transactionId = atom({
  key: RECOIL_KEYS.HISTORY_PAGE_SELECTED_TRANSACTION,
  default: "" as string,
});

export const startTimer = atom({
  key: RECOIL_KEYS.START_TIMER,
  default: false as Boolean,
});

export const showTimerText = atom({
  key: RECOIL_KEYS.SHOW_TIMER_TEXT,
  default: false as Boolean,
});

export const triggerTransactionSummary = atom({
  key: RECOIL_KEYS.TRIGGER_TRANSACTION_SUMMARY,
  default: false as Boolean,
});

export const selectedTransactionID = atom<string>({
  key: RECOIL_KEYS.HISTORY_PAGE_SELECTED_TRANSACTION_ID,
  default: "",
});

export const selectedTransactionRejectionStatus = atom<boolean>({
  key: RECOIL_KEYS.HISTORY_PAGE_SELECTED_TRANSACTION_REJECTION_STATUS,
  default: false,
});

export const historyPageSelectedTransaction = atom<string>({
  key: RECOIL_KEYS.TRANSACTION_ID,
  default: "",
});

export const currentRole = atom<string>({
  key: RECOIL_KEYS.CURRENT_ROLE,
  default: {} as any,
  effects_UNSTABLE: [persistAtom],
});

export const timerState = atom({
  key: RECOIL_KEYS.TIMER_STATE,
  default: false as boolean,
  effects_UNSTABLE: [persistAtom],
});

export const remitterID = atom({
  key: RECOIL_KEYS.REMITTER_ID,
  default: "" as string,
});

export const historyPageEsignModal = atom({
  key: RECOIL_KEYS.HISTORY_PAGE_ESIGN_MODAL,
  default: {} as HistoryPageEsignModalProps,
});

export const roundOffValue = atom({
  key: RECOIL_KEYS.ROUND_OFF,
  default: false as boolean,
});

export const panDeclaration = atom({
  key: RECOIL_KEYS.PAN_DECLARATION,
  default: "" as string,
});

export const selectedPurpose = atom({
  key: RECOIL_KEYS.SELECTED_PURPOSE_CODE,
  default: { purposeCode: "", purposeValue: "" },
});

export const selectedVendor = atom({
  key: RECOIL_KEYS.SELECTED_VENDOR,
  default: "" as string,
});

export const selectVendor = atom({
  key: RECOIL_KEYS.SELECTED_VENDOR,
  default: { vendorCode: "", displayName: "", userId: "" },
});

export const fromDateState = atom({
  key: "fromDateState",
  default: dayjs().subtract(1, "month").format("YYYY-MM-DD"),
});

export const toDateState = atom({
  key: "toDateState",
  default: dayjs().format("YYYY-MM-DD"),
});
